import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function PainSection() {
  const pains = ['Es abrir tu panel de afiliados y ver el mismo número de cero. Semana tras semana.', 'Es crear contenido durante meses y que nadie haga clic en tus enlaces.', 'Es mirar cómo otros en tu mismo grupo de networking hablan de sus primeras comisiones... mientras tú finges que también te va bien.', 'Es la conversación incómoda cuando alguien te pregunta: «¿Y cómo va tu negocio de afiliados?»'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative overflow-hidden" data-id="element-139" data-mp="2q15i0tft839j">
      {/* Subtle background texture/gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-navy-800/20 via-navy-900 to-navy-900 pointer-events-none" data-id="element-140" data-mp="2g8pznv0lpco4" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-141" data-mp="22buex5azlws8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center text-center mb-12" data-id="element-142" data-mp="2779qfqlivglh">
          <div className="w-16 h-16 bg-navy-800 rounded-full flex items-center justify-center mb-6 border border-white/5 shadow-lg" data-id="element-143" data-mp="gg8ggoroehj">
            <AlertTriangle className="w-8 h-8 text-slate-400" data-id="element-144" data-mp="38wsvlg3asrxb" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-145" data-mp="33yrciv5vgslu">
            El Dolor Que Nadie Nombra
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl" data-id="element-146" data-mp="3innlqvjo0bo1">
            ¿Sabes cuál es la parte más dolorosa de todo esto? No es el dinero
            que no entra.
          </p>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-147" data-mp="2q470wz44n7eb">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6
        }} className="bg-navy-950/50 border border-white/5 p-6 rounded-xl backdrop-blur-sm hover:border-white/10 transition-colors" data-id="element-148" data-mp="2l6fbqcuv9zdt" data-mpi={index}>
              <p className="text-lg text-slate-300 font-light" data-id="element-149" data-mp="b39d700wfffv">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8,
        duration: 0.8
      }} className="text-center" data-id="element-150" data-mp="f42yrmqvci5l">
          <p className="text-xl text-slate-400 mb-2" data-id="element-151" data-mp="1vlpcruirlg9w">
            Eso duele. Y nadie lo habla abiertamente.
          </p>
          <p className="text-3xl font-serif text-gold-400 font-medium" data-id="element-152" data-mp="20ozsw64629uo">
            Pero hoy cambia.
          </p>
        </motion.div>
      </div>
    </section>;
}